import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=6d90a0a2&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=6d90a0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90a0a2",
  null
  
)

export default component.exports